
// import Notice from "~/components/home/notice.vue";
import BannerTop from "@/components/home/bannerTop.vue";
import CommonTitle from "@/components/home/commonTitle.vue";
export default {
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      bannerUrl:require("@/static/images/coreTechnology/banner.png"),
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/coreTechnology/arcturus/arcturus1.png`),
        }
      ],
      imgUrl: require(`@/static/images/coreTechnology/arcturus/2${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
    }
  },
  computed: {
    contentList () {
      return this.$t('technology.arcturus.contentList')
    },
  },
}
